import { EmphasisBlockProps, EmphasisBlock, Block, Divider, DividerProps } from 'ia-react-core';

import { FC } from 'react';
import styled from 'styled-components';

export const StyledBlock = styled(Block)`
  box-shadow: none !important;
  padding: 0;
  padding-left: 0 !important;
  padding-top: 0;
  background: transparent;
  padding-top: 26px !important;
  padding-bottom: 36px !important;
 `;

export const StyledEmphasisBlock = styled<FC<EmphasisBlockProps>>(EmphasisBlock)`
  padding-top: 26px !important;
  padding-right: 0 !important;
 `;

export const StyledDiv = styled.div`
  padding: 0;
 `;

export const StyledDivHeader = styled.div`
padding: 16px;
`;
export const StyledText = styled.span`
font-size: 14px;
line-height: 1.29;
`;

export const StyledDivider = styled<FC<DividerProps>>(Divider)`
  padding-right: 0px !important;
  background-color : ${({ theme }) => theme.colors.gray4};
  height: 1px;
 `;

export const StyledRowWrapper = styled.div`
    padding: 8px 8px 0px 12px;
`;
